const propsComparator = <S>(keys: string[], prevProps: any, currentProps: any) => {
  const update: any = {};
  for (const key of keys) {
    const current = currentProps[key];
    if (prevProps[key] !== current) {
      update[key] = current;
    }
  }

  if (Object.keys(update).length === 0) {
    return null;
  }

  return update as S;
};

export default propsComparator;
